module.exports = __webpack_public_path__ + "img/img4.b4ba3ba7.png";